angular.module('impactx.search').component('ixCatalogList', {
        bindings: {
            catalogs: '<',
            trns: '<',
        },
        require: {
            containerCtrl: '^^ixListTabContainer'
        },
        controller: 'CatalogSearchListCtrl',
        controllerAs: 'catalogSearchListCtrl',
        templateUrl: 'modules/search/templates/catalog-list.html'
    }
);